const TOKEN_PATTERN = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

export const getEmbedAuthorizationContext = (
  location = typeof window !== 'undefined' ? window.location : {}
) => {
  try {
    const params = new URLSearchParams(location.search || '');
    if (params.get('embed') !== '1' && params.get('lvm_embed') !== '1') return null;
    const token = String(params.get('lvm_embed_authorization') || '').trim();
    const origin = String(params.get('lvm_parent_origin') || '').trim();
    if (!TOKEN_PATTERN.test(token) || token.length > 2048) return null;
    const parsedOrigin = new URL(origin);
    const comparable = origin.endsWith('/') ? origin.slice(0, -1) : origin;
    if (parsedOrigin.protocol !== 'https:' || parsedOrigin.origin !== comparable) return null;
    return { token, origin: parsedOrigin.origin };
  } catch (error) {
    return null;
  }
};

export const appendEmbedAuthorizationToPayload = (payload = {}, location) => {
  const context = getEmbedAuthorizationContext(location);
  return context ? {
    ...payload,
    embedAuthorization: context.token,
    embedOrigin: context.origin
  } : payload;
};
